import { AttackType, Team } from "../../types/enum/Game"
import type { Board } from "../board"
import { OnAttackEffect } from "../effects/effect"
import type { PokemonEntity } from "../pokemon-entity"
import { AbilityStrategy } from "./ability-strategy"

export class VoltSurgeStrategy extends AbilityStrategy {
  requiresTarget = false
  process(pokemon: PokemonEntity, board: Board, target: null, crit: boolean) {
    super.process(pokemon, board, target, crit)
    const hpGained = [10, 20, 30, 60][pokemon.stars - 1] ?? 60
    pokemon.addMaxHP(hpGained, pokemon, 1, crit, false)
    pokemon.addSpeed(20, pokemon, 0, false)
    if (pokemon.status.electricField === false) {
      pokemon.status.electricField = true
      pokemon.broadcastAbility({ skill: "SUPERCHARGE" })
    }

    if (pokemon.count.ult === 1) {
      let localCount = 0
      pokemon.effectsSet.add(
        new OnAttackEffect(({ pokemon, board }) => {
          localCount++
          if (localCount % 3 !== 0) return

          const closestEnemies = board.getClosestEnemies(
            pokemon.positionX,
            pokemon.positionY,
            pokemon.team === Team.RED_TEAM ? Team.BLUE_TEAM : Team.RED_TEAM
          )
          let previousTarget: PokemonEntity = pokemon
          for (const secondaryTarget of closestEnemies.slice(0, 4)) {
            pokemon.broadcastAbility({
              skill: "LINK_CABLE_link",
              positionX: previousTarget.positionX,
              positionY: previousTarget.positionY,
              targetX: secondaryTarget.positionX,
              targetY: secondaryTarget.positionY
            })
            secondaryTarget.handleSpecialDamage(
              20,
              board,
              AttackType.SPECIAL,
              pokemon,
              false
            )
            previousTarget = secondaryTarget
          }
        })
      )
    } else {
      pokemon.cooldown = 0 // no cooldown for subsequent ultimates
    }
  }
}
